<template>
  <div class="parallax-row relative grid grid-cols-2 py-18px lg:py-120px">
    <div class="col-span-2 lg:col-span-1">
      <h3 class="mb-4 text-40px font-extrabold text-www-color-neutral-medium-dark">
        {{ title }}
      </h3>
      <PortableText
        v-if="description?.homePagePortableText"
        :portable-data="description.homePagePortableText"
      />
    </div>
    <div class="relative col-span-2 lg:col-span-1">
      <div class="pin-container">
        <PtcPicture
          v-if="image?.asset"
          provider="sanity"
          format="webp"
          :src="image.asset._ref"
          :alt="resolvedImage?.altText || 'Parallax image'"
          :img-attrs="{ class: { 'sticky-image block mx-auto p-0 w-full h-auto lg:w-auto': true } }"
          :modifiers="{ crop: image.crop, hotspot: image.hotspot }"
          loading="lazy"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import PortableText from '~/components/Atmos/PortableText/PortableText.vue';
import PtcPicture from '~/components/Atmos/PtcPicture/PtcPicture.vue';
import type { ParallaxDeck } from '~/sanity/types';

const props = defineProps<ParallaxDeck>();
const { getResolvedImage } = useRefsStore();
const resolvedImage = await getResolvedImage(props.image?.asset?._ref);
</script>

<style lang="scss" scoped></style>
